import { transmissionTooltipHandler } from "./transmissionTooltipHandler";

const useTransmissionChart = (data) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    plugins: {
      tooltip: {
        enabled: false,
        position: "nearest",
        external: transmissionTooltipHandler,
      },
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 5,
          boxHeight: 5,
          usePointStyle: true,
        },
      },
    },

    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
        beginAtZero: true,
        title: {
          display: true,
          text: "No. of Transmission",
        },
      },
    },
  };

  const chartData = {
    labels: data?.labels,
    datasets: [
      {
        label: "Non Billable",
        nonBillableReports: data?.nonBillable?.map((total) => total),
        data:
          data?.nonBillable?.length > 0
            ? data?.nonBillable?.map(
                (nonBillable) =>
                  nonBillable
                    ?.filter((item) => item?.title === "Non Billable")
                    ?.map((item) => item?.count)?.[0]
              )
            : [],
        borderColor: "#bdbdbd",
        backgroundColor: "#bdbdbd",
        barThickness: 25,
      },
      {
        label: "Billable",
        billableReports: data?.billable.map((billable) => billable),
        data:
          data?.billable?.length > 0
            ? data?.billable?.map(
                (billable) =>
                  billable
                    ?.filter((item) => item?.title === "Billable")
                    ?.map((item) => item?.count)?.[0]
              )
            : [],
        borderColor: "#94ba33",
        backgroundColor: "#94ba33",
        barThickness: 25,
      },
    ],
  };

  return { options, chartData };
};

export default useTransmissionChart;
